import Vue from 'vue';
import { logger } from '@utils/weblog';
interface Binding {
    value?: {
        eventName: string;
        params: any;
        content_wrapper?: {
            [key: string]: {
                business_line: string;
                custom: {
                    source: string;
                };
            };
        };
    };
}

function sendElementIn(logger: any, obj: Binding['value']) {
    logger.sendImmediately('SHOW', obj!.eventName, obj!.params, JSON.stringify(obj!.content_wrapper));
}

// 元素从页面上离开
// 离开不打点
function sendElementOut(logger: any, obj: Binding['value'], stayLength: number) {}

const ob = new IntersectionObserver(
    (els: IntersectionObserverEntry[]) => {
        els.forEach(entry => {
            // @ts-ignore
            const dataset = entry?.target?.dataset || {};
            if (!entry.isIntersecting) {
                return;
            }
            if (!Object.prototype.hasOwnProperty.call(dataset, 'logParams')) {
                return;
            }
            const logParams = JSON.parse(dataset.logParams);
            sendElementIn(logger, logParams);
            delete dataset.logParams;
        });
    },
    {
        threshold: [0],
    }
);

export default Vue.directive('showlog', {
    inserted(el: HTMLElement, binding: Binding) {
        el.dataset.logParams = JSON.stringify(binding.value);
        ob.observe(el);
    },
    unbind(el: HTMLElement, binding: Binding) {
        ob.unobserve(el);
    },
});
